module.exports = function() {
  return new Worker(__webpack_public_path__ + "514982cff60d7e89991d.worker.js");
};